<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span jhiTranslate="bmsjHipsterApp.sample.genotypes.header">Import Genotypes</span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="close()">
    </button>
</div>
<div *ngIf="showFileUpload">
    <div class="modal-body">
        <div class="mb-3 row">
            <div class ="col-md-12">
                <span jhiTranslate="bmsjHipsterApp.sample.genotypes.import.instruction"></span>
            </div>
        </div>
        <div class="row mb-3 add_top_padding" style="margin-bottom: 35px;">
            <div class="col-2"></div>
            <div class="col-md-8">
                <label class="form-label" for="fileUpload"><i class="fa fa-search"></i> {{'bmsjHipsterApp.sample.genotypes.import.label' | translate}} </label>

				<jhi-file-select id="fileUpload"
								 [acceptedFileTypes]="selectedFileType"
								 (fileSelected)="onFileChange($event)"
								 (fileCleared)="clearSelectedFile()">
				</jhi-file-select>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="close()">
                <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
            </button>
            <button (click)="import()" class="btn btn-primary" [disabled]="fileName === '' ? 'disabled' : null">
                <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.import">Import</span>
            </button>
        </div>
    </div>
</div>
<div *ngIf="!showFileUpload">
    <div class="modal-body">
        <div class="mb-3 row">
            <label class="fw-bold" jhiTranslate="bmsjHipsterApp.sample.genotypes.mapped.header">Mapped Variants</label>
        </div>
        <div class="row">
            <div class="col-md-12">
                <span jhiTranslate="bmsjHipsterApp.sample.genotypes.markers.map.description" [translateValues]="{param1: MARKER_MAPPING_ITEM_COUNT_LIMIT}"></span>
                <br><br>
            </div>
        </div>
        <div class="mb-3 row">
            <div class="col-md-12">
                <div class="table-responsive">
                    <div class="custom-scroll-style" style="min-height: 300px; max-height: 500px; overflow-y: auto">
                    <table class="table table-striped table-bordered table-curved">
                        <thead class="sticky-header">
                        <tr>
                            <th jhiTranslate="bmsjHipsterApp.sample.genotypes.marker.column">Marker</th>
                            <th jhiTranslate="bmsjHipsterApp.sample.genotypes.variable.column">Variable</th>
                            <th jhiTranslate="bmsjHipsterApp.sample.genotypes.action.column">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let item of mappedMarkers.values()">
                            <td>{{item.markerName}}</td>
                            <td>{{item.variable.name}}</td>
                            <td class="fit">
                                <button class="btn btn-info me-2" (click)="removeMappedMarker(item.markerName)">
                                    <i class="fa fa-trash fa-md" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                        <tr *ngIf="showAddMappingRow || (mappedMarkers && mappedMarkers.size === 0)">
                            <td>
                                <ng-select #rowMarkerSelect
                                           [ngStyle]="{'min-width': '85%'}"
                                           placeholder="{{ 'bmsjHipsterApp.sample.genotypes.select.marker' | translate }}"
                                           [items]="markerSelectItems" [(ngModel)]="selectedMarker"
                                           [disabled]="!markerSelectItems || markerSelectItems?.length === 0"
                                           bindLabel="markerName"
                                           [searchFn]="searchMarker"
                                           name="markerSelect" id="markerSelect"
                                           [dropdownPosition]="'bottom'"
                                           [virtualScroll]="true">
                                    <ng-template ng-option-tmp let-marker="item">
                                        <div title="{{marker}}">{{marker}}</div>
                                    </ng-template>
                                </ng-select>
                            </td>
                            <td>
                                <jhi-variable-select name="dropdownRowVariable" id="dropdownRowVariable"
                                                     (onVariableSelectedChange)="selectVariable($event)"
                                                     [value]="selectedVariable?.id"
                                                     [variableTypeIds]="[genotypeMarkersId]"
                                                     [disabled]="!markerSelectItems || markerSelectItems?.length === 0">
                                </jhi-variable-select>
                            </td>
                            <td class="fit">
                                <button type="button" class="btn btn-primary" [disabled]="!selectedMarker || !selectedVariable" (click)="mapMarker()" jhiTranslate="bmsjHipsterApp.sample.importPlate.mapping.map">Map</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <button type="button" class="btn btn-primary" *ngIf="showAddMappingButton()" [disabled]="!markerSelectItems || markerSelectItems?.length === 0" (click)="addMapping()">
                        <i class="fa fa-plus"></i><span class="ms-2" jhiTranslate="bmsjHipsterApp.sample.genotypes.add.another.mapping">Add another mapping</span>
                    </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()" aria-hidden="true">
            {{'cancel' | translate}}
        </button>
        <button type="button" class="btn btn-primary ms-2" [disabled]="!mappedMarkers || mappedMarkers.size === 0" (click)="importGenotypes()">
            {{ 'entity.action.import' | translate}}
            <span *ngIf="isGenotypesSaving" class="throbber"></span>
        </button>
    </div>
</div>
